var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEjip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EJIP",
    transform: "translate(0.006 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M23.369,185.573l-1.23.839c-.26-.376-.5-.722-.738-1.069q-2.5-3.64-5-7.286a.676.676,0,0,0-.638-.356c-1.991.017-3.982,0-5.972.021a.791.791,0,0,0-.561.287c-2.26,3.258-4.52,6.514-6.74,9.8a5.286,5.286,0,0,0-.337,5.743,5.328,5.328,0,0,0,4.975,2.973c3.7.024,7.4.006,11.1.006h.55v1.506h-.43c-3.747,0-7.493.011-11.24,0A7.058,7.058,0,0,1,0,190.646,7.139,7.139,0,0,1,1.341,186.8q3.338-4.836,6.649-9.69a2.18,2.18,0,0,0,.273-.858,4.008,4.008,0,0,0-1.217-3.692,4.847,4.847,0,0,1-.509-.676,2.675,2.675,0,0,1,3.3-4c.879.41,1.746.849,2.6,1.3a.652.652,0,0,0,.691-.005c.775-.409,1.566-.788,2.35-1.179a2.689,2.689,0,0,1,3.429,4.05,3.738,3.738,0,0,1-.369.487,4.075,4.075,0,0,0-1.239,3.779,1.944,1.944,0,0,0,.252.771q2.736,4.023,5.5,8.026c.1.141.187.285.309.47Zm-10.583-12.38c1,0,2,.018,3.005-.014a.923.923,0,0,0,.606-.3c.459-.553.875-1.142,1.3-1.721a1.191,1.191,0,0,0-1.513-1.829c-.952.472-1.909.937-2.85,1.429a1.093,1.093,0,0,1-1.107,0c-.956-.5-1.925-.972-2.892-1.449a1.185,1.185,0,0,0-1.5,1.815c.436.592.864,1.192,1.333,1.757a.92.92,0,0,0,.605.3c1,.031,2,.014,3.005.014Zm-2.991,2.978h5.963v-1.448H9.795Z",
    transform: "translate(0 -153.051)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    d: "M122.644,4.548v9.73h-1.477V4.513c-.278,0-.507.01-.736,0a.736.736,0,0,1-.782-.761q-.024-1.5,0-3.01A.728.728,0,0,1,120.406,0c.125-.009.251,0,.376,0h18.81c.925,0,1.125.2,1.125,1.133q0,1.176,0,2.352c0,.8-.234,1.026-1.038,1.032h-.461V33.1H137.73V4.548H122.645Zm-1.473-1.57h18V1.526h-18Z",
    transform: "translate(-109.178 0)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    d: "M215.51,396.637c-.308-1.609.347-2.753,1.712-3.031a3.642,3.642,0,0,1,.7-.046q4.184,0,8.368,0a2.317,2.317,0,0,1,2.582,1.764c.266,1.114-.263,2.04-1.549,2.689a6.737,6.737,0,0,1,.1.821,6.526,6.526,0,0,1-.1.817,2.4,2.4,0,0,1,1.467,1.4,2.23,2.23,0,0,1-1.99,3.031q-4.629.058-9.26,0a2.219,2.219,0,0,1-2.082-2.751c.02-.091.037-.182.061-.3a2.3,2.3,0,0,1,0-4.393Zm6.7,4.45q-2.187,0-4.374,0c-.595,0-.937.281-.937.751s.342.752.936.753q4.328,0,8.655,0c.592,0,.938-.283.938-.752s-.344-.751-.937-.752q-2.14,0-4.28,0Zm-1.552-1.506q2.163,0,4.328,0c.591,0,.938-.284.937-.753s-.344-.751-.938-.751q-4.328,0-8.655,0c-.594,0-.936.282-.936.752s.344.751.937.752Q218.49,399.584,220.654,399.581Zm1.509-4.517q-2.163,0-4.328,0c-.6,0-.938.277-.942.747s.341.757.933.757q4.328,0,8.655,0c.594,0,.939-.28.942-.748s-.34-.755-.933-.756c-1.442,0-2.885,0-4.328,0Z",
    transform: "translate(-195.164 -359.113)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4020",
    "data-name": "Path 4020",
    d: "M372.963,223.157v1.462h-10.5v-1.462h6.712V198.31H359.45v-1.49c.149-.007.3-.02.449-.02q4.892,0,9.784,0c.8,0,1.034.235,1.034,1.036v25.324h2.247Z",
    transform: "translate(-327.969 -179.668)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4021",
    "data-name": "Path 4021",
    d: "M365.116,47.292h-1.483V40.381L357.44,39c.1-.481.2-.945.313-1.455l1.347.268V34.53h1.48v3.623l1.528.342V36.037h1.478v2.776l.884.212a.724.724,0,0,1,.64.709C365.121,42.239,365.116,44.744,365.116,47.292Z",
    transform: "translate(-326.136 -31.495)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    d: "M122.719,360.055h-1.526c.2-.644-.188-.9-.643-1.2a1.976,1.976,0,0,1-.84-1.762h1.462c.077.438.292.752.82.733a.662.662,0,0,0,.7-.5.612.612,0,0,0-.368-.734c-.43-.223-.865-.439-1.3-.654a2.165,2.165,0,0,1-.057-3.951.625.625,0,0,0,.234-.381,2.286,2.286,0,0,0,.01-.531h1.457c.019.048.043.078.039.1a.893.893,0,0,0,.56,1.018,1.975,1.975,0,0,1,.951,1.841h-1.428c-.235-.619-.449-.82-.942-.708a.868.868,0,0,0-.583.485.829.829,0,0,0,.309.688,9.9,9.9,0,0,0,1.33.692,2.166,2.166,0,0,1,.058,3.952.622.622,0,0,0-.235.381,2.312,2.312,0,0,0-.01.534Z",
    transform: "translate(-109.219 -320.364)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    d: "M222.7,68.72h2.955v1.448H222.7Z",
    transform: "translate(-203.175 -62.676)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M419.29,343.967V342.52h2.951v1.447Z",
    transform: "translate(-382.543 -312.509)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M222.57,138.638V137.19h2.951v1.448Z",
    transform: "translate(-203.057 -125.172)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M422.31,412.558h-2.95V411.11h2.95Z",
    transform: "translate(-382.607 -375.12)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M277,104.484H274.05V103.03H277Z",
    transform: "translate(-250.022 -94.005)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    d: "M174.385,137.25v1.436H171.42V137.25Z",
    transform: "translate(-156.392 -125.227)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M273.96,171.38h2.948v1.453H273.96Z",
    transform: "translate(-249.94 -156.366)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M222.58,104.408V102.96h2.951v1.448Z",
    transform: "translate(-203.066 -93.941)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M171.26,104.408V102.96h2.951v1.448Z",
    transform: "translate(-156.246 -93.941)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M174.371,68.82v1.452H171.42V68.82Z",
    transform: "translate(-156.392 -62.767)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M276.878,68.86V70.3H273.91V68.86Z",
    transform: "translate(-249.894 -62.804)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M422.4,378.235H419.45V376.78H422.4Z",
    transform: "translate(-382.689 -343.767)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M277.021,239.93v1.45H274.07v-1.45Z",
    transform: "translate(-250.04 -218.909)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M370.978,239.97v1.442H368.01V239.97Z",
    transform: "translate(-335.742 -218.945)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M422.288,239.96V241.4H419.32V239.96Z",
    transform: "translate(-382.57 -218.936)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M422.408,446.693H419.46V445.24h2.948Z",
    transform: "translate(-382.698 -406.247)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M276.949,205.63v1.448H273.99V205.63Z",
    transform: "translate(-249.967 -187.615)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M273.85,275.551V274.11h2.968v1.441Z",
    transform: "translate(-249.84 -250.094)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M367.94,275.559V274.12h2.967v1.439Z",
    transform: "translate(-335.678 -250.103)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    "data-name": "Path 4042",
    d: "M419.3,275.518V274.07h2.951v1.448Z",
    transform: "translate(-382.552 -250.057)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    "data-name": "Path 4043",
    d: "M274.06,308.22h2.948v1.464H274.06Z",
    transform: "translate(-250.031 -281.215)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4044",
    "data-name": "Path 4044",
    d: "M371.121,309.853H368.18V308.39h2.941v1.462Z",
    transform: "translate(-335.897 -281.37)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4045",
    "data-name": "Path 4045",
    d: "M422.31,309.888h-2.95V308.44h2.95Z",
    transform: "translate(-382.607 -281.415)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4046",
    "data-name": "Path 4046",
    d: "M367.98,343.958V342.51h2.951v1.448Z",
    transform: "translate(-335.715 -312.5)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4047",
    "data-name": "Path 4047",
    d: "M276.967,137.2v1.445H274.01V137.2Z",
    transform: "translate(-249.986 -125.181)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M241.25,274.1v1.442H239.8V274.1Z",
    transform: "translate(-218.773 -250.085)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4049",
    "data-name": "Path 4049",
    d: "M241.258,241.355H239.81V239.9h1.448Z",
    transform: "translate(-218.782 -218.882)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4050",
    "data-name": "Path 4050",
    d: "M87.2,395.418H85.75V393.97H87.2Z",
    transform: "translate(-78.21 -359.451)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4051",
    "data-name": "Path 4051",
    d: "M189.843,393.96V395.4H188.38V393.96Z",
    transform: "translate(-171.863 -359.442)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4052",
    "data-name": "Path 4052",
    d: "M241.25,205.66V207.1H239.8V205.66Z",
    transform: "translate(-218.773 -187.642)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4053",
    "data-name": "Path 4053",
    d: "M241.176,173H239.73V171.55h1.446Z",
    transform: "translate(-218.709 -156.521)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4054",
    "data-name": "Path 4054",
    d: "M395.276,155.872H393.84V154.41h1.436Z",
    transform: "translate(-359.303 -140.883)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4055",
    "data-name": "Path 4055",
    d: "M360.975,154.3v1.448H359.52V154.3Z",
    transform: "translate(-327.993 -140.782)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4056",
    "data-name": "Path 4056",
    d: "M393.63,121.536V120.09h1.447v1.446Z",
    transform: "translate(-359.111 -109.57)",
    fill: "#e24f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    "data-name": "Path 4057",
    d: "M359.49,120.05h1.444V121.5H359.49Z",
    transform: "translate(-327.966 -109.534)",
    fill: "#e24f56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEjip);
export default __webpack_public_path__ + "static/media/EJIP.f9b9ab0c434d80726089f82f216dd795.svg";
export { ForwardRef as ReactComponent };